import Interceptor from '../Interceptor'
import Env from '../../services/Env'

export default class InterceptorOcr {
  api: any = new Interceptor()
  config: any = {
    baseURL: Env.API_FINX_OCR,
    headers: {}
  }

  delete(url: string): any {
    return this.api.delete(url, this.config)
  }

  get(url: string): any {
    return this.api.get(url, this.config)
  }

  post(url: string, data: any): any {
    return this.api.post(url, data, this.config)
  }

  postFormData(url: string, data: any): any {
    this.config.headers = { 'Content-Type': 'multipart/form-data' }
    return this.api.post(url, data, this.config)
  }

  put(url: string, data: any): any {
    return this.api.put(url, data, this.config)
  }
}
